import { Client } from '@twilio/conversations';
import { useContext } from 'react';

import { TwilioConversationsClientContext } from './TwilioConversationsClientProvider';

/**
 * Returns the app-wide Twilio Conversations Client singleton owned
 * by `TwilioConversationsClientProvider` (mounted above `<Routing />`
 * in App.tsx). Every consumer shares one Client instance — and
 * therefore one WebSocket — for the entire logged-in session.
 *
 * Returns `null` during the bootstrap window (no user logged in, or
 * initial token mint in flight).
 */
export default function useTwilioConversationsClient(): Client | null {
  return useContext(TwilioConversationsClientContext);
}
